import JobDetailCard from './JobDetailCard';

export default JobDetailCard;




// WEBPACK FOOTER //
// ./src/components/JobDetailCard/index.js